import React, { useEffect, useState } from 'react'

import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'

import ViewsLoader from '../../components/loader/ViewsLoader'
import { Button } from '../../components/ui/button'

import { httpService } from '../../services/httpService'

const SendRequestPaymentPage = () => {
  const { search } = useLocation()

  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')

  useEffect(() => {
    const params = new URLSearchParams(search)

    const token = params.get('token')
    const pmId = params.get('pmId')
    const userId = params.get('userId')

    const fetchData = async () => {
      if (!token || !pmId || !userId) {
        setMessage('Your data is wrong.')
        return
      }

      try {
        setLoading(true)

        await httpService({
          url: 'approve_request_payment',
          method: 'POST',
          data: {
            userId: userId,
            pmId: pmId,
            token: token,
          },
        })

        setMessage('Payment access has been successfully approved.')
      } catch (error: any) {
        console.error('error: ', error)
        setMessage(
          error?.response?.data?.error ??
            'Something went wrong while processing your request. Please try again later.'
        )
      } finally {
        setLoading(false)
      }
    }
    fetchData().then()
  }, [search])

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[200px]">
        <ViewsLoader
          className="flex items-center w-full justify-center min-h-[30vh] mt-3"
          size="lg"
          color="#F70763"
        />
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center min-h-screen h-full py-10 px-4">
      <div className="w-full max-w-md rounded-2xl shadow-lg p-8 text-center bg-white">
        <h2 className="text-black text-lg leading-normal">{message}</h2>
        <div className="mt-6">
          <Button variant="red">
            <Link to="/">Go to Home</Link>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default SendRequestPaymentPage
